define(['jquery'], $ => {
    return {
        init() {
            $('body').on('click', '.js-scroll-to-top-link', e => {
                e.preventDefault();

                $('html, body').animate({ scrollTop: 0 }, 300);
            });
        },
    };
});
